module.exports = __webpack_public_path__ + "img/sit_stand_desks.102e96d5.png";